import CookieService from "../../../../../../common/ts/services/CookieService";
import {CssBreakpoints} from "../../../CssBreakpoints";

const SCROLL_ALERT_SHOWN_COUNT_COOKIE = 'nestoria_scroll_alert_count';
const COOKIE_EXPIRY_DAYS = 365;
const MAX_SCROLL_ALERT_SHOWS = 2;
const SCROLL_THRESHOLD = 900;

export class ScrollAlert {
    private readonly alert: HTMLElement | null;
    private readonly cookieService: CookieService;

    private dismissed: boolean = false;
    private shownThisSession: boolean = false;
    private onButtonClickCallback: (() => void) | null = null;

    constructor() {
        this.alert = document.querySelector('.js-serp-scroll-alert');
        this.cookieService = new CookieService();
    }

    init(): void {
        if (!this.alert) return;

        if (this.getShowCount() >= MAX_SCROLL_ALERT_SHOWS) {
            this.dismissed = true;
            return;
        }

        window.addEventListener('scroll', () => this.handleScroll());

        const closeButton = this.alert.querySelector('.js-serp-scroll-alert-close');
        closeButton?.addEventListener('click', () => this.hide());

        const alertButton = this.alert.querySelector('.js-serp-scroll-alert-button');
        alertButton?.addEventListener('click', () => {
            this.hide();
            this.onButtonClickCallback?.();
        });
    }

    isAvailable(): boolean {
        return this.alert !== null;
    }

    onButtonClick(callback: () => void): void {
        this.onButtonClickCallback = callback;
    }

    dismiss(): void {
        this.dismissed = true;
        this.hide();
    }

    hide(): void {
        this.dismissed = true;
        this.alert?.classList.remove('visible');
    }

    private handleScroll(): void {
        if (this.dismissed || this.isMobile()) {
            return;
        }

        const scrollY = window.scrollY || window.pageYOffset;

        if (scrollY > SCROLL_THRESHOLD) {
            this.show();
        }
    }

    private show(): void {
        if (!this.alert || this.dismissed) return;

        if (!this.shownThisSession) {
            this.shownThisSession = true;
            this.incrementShowCount();
        }
        this.alert.classList.add('visible');
    }

    private isMobile(): boolean {
        return !CssBreakpoints.get().isDesktop();
    }

    private getShowCount(): number {
        const count = this.cookieService.getCookie(SCROLL_ALERT_SHOWN_COUNT_COOKIE);
        return count ? parseInt(count, 10) : 0;
    }

    private incrementShowCount(): void {
        const currentCount = this.getShowCount();
        this.cookieService.setExpirableCookie(SCROLL_ALERT_SHOWN_COUNT_COOKIE, String(currentCount + 1), COOKIE_EXPIRY_DAYS);
    }
}
